export const en = {
  global: {
    my: 'my',
    policies: 'Policies',
    quotes: 'Quotes',
    claims: 'Claims',
    speakWithAnAdvisor: 'Speak with an Advisor',
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout',
    car: 'Car',
    home: 'Home',
    life: 'Life',
    health: 'Health',
    yacht: 'Yacht',
    travel: 'Travel',
    bike: 'Bike',
    insurance: 'Insurance',
    hello: 'Hello',
    thankYouForRequest:
      'Thank you for your request. Your Personal Shopper will call you shortly!',
    save: 'Save',
    reset: 'Reset',
    thankYou: 'Thank You',
    email: 'Email',
    isRequired: 'is required',
    mustValidEmail: 'Must be a valid email',

    //yacht modal
    personalDetails: 'Personal Details',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    must3Alphabets: 'Must be 3 Alphabets minimum',
    max20Alphabets: 'Maximum 20 Alphabets allowed',
    mustValidPhoneNumber: 'Must be a valid UAE phone number',

    // footer
    compare: 'Compare',
    companies: 'Companies',
    aboutUs: 'About Us',
    guides: 'Guides',
    bussiness: 'Bussiness',
    RSA: 'RSA',
    AXA: 'AXA',
    OMAN: 'OMAN',
    noorTakaful: 'Noor Takaful',
    NGI: 'NGI',
    coverage: 'Coverage',
    comparison: 'Comparison',
    discounts: 'Discounts',
    ourStory: 'Our Story',
    leadership: 'Leadership',
    contactUs: 'Contact Us',
    sitemap: 'Sitemap',
    privacy: 'Privacy',
    media: 'Media',
    eBooks: 'eBooks',
    blogs: 'Blogs',
    CEOBlog: "CEO's Blog",
    knowYourInsurance: 'Know Your Insurance',
    askTheExpert: 'Ask The Expert',
    FAQ: 'FAQ',

    footerTagLine1:
      '© AFIA Insurance Brokerage Services LLC, Registration No. 85 under UAE Insurance Authority Reserved.',
    footerTagLine2:
      'Holder of HIIP from DHA, Intermediary ID No. BRK-00003 | Registered Member of Emirates Insurance Association',
  },
  '/yacht-insurance': {
    // SEO //
    title: 'Yacht Insurance | Boat Insurance Dubai UAE',
    metaDesc:
      'Custom yacht insurance services in Dubai and across UAE for protection of your commercial vessel, boat, pleasure craft, jet ski or yacht. Visit InsuranceMarket.ae to get your yacht insurance in minutes.',
    // SectionBanner //
    rating: 'Rating',
    reviews: 'Reviews',
    compareYacht: 'COMPARE YACHT INSURANCE WITH ALFRED',
    floatAround: 'Float around the Gulf sea with complete peace of mind',
    getQuotes: 'Get quotes in your email',
    weWillEmail:
      'We’ll email a comparison table, help you choose and email your policy!',

    // SectionPartners //
    ourYachtInsurance: 'OUR YACHT INSURANCE PARTNERS',
    oneSizeDoesNot:
      'One size does not fit all. We work with the Leading Yacht Insurance companies in the UAE to tailor the right policy for you.',

    // SectionPleasureCraft //
    benefitsOfPleasure: 'BENEFITS OF PLEASURE CRAFT INSURANCE',

    hullnMachinery: 'Hull and Machinery',
    coversTheLoss:
      'Covers the loss or damage to your yacht caused by insured perils.',
    thirdPartyLiability: 'Third Party Liability',
    coversYouAgainst:
      'Covers you against liabilities that may arise out of injury to a third party person or damage to a property.',
    unInsuredBoater: 'Uninsured Boater',
    coversYouAndGuests:
      'Covers you and guests on your pleasure craft against bodily injury.',
    personalEffects: 'Personal Effects',
    isAnOptional:
      'Is an optional coverage which covers your personal belongings on your boat from theft.',
    searchAndRescue: 'Search and Rescue Services',
    coversExpenses:
      'Covers expenses for this service in the event assistance is required.',
    racingRiskCoverage: 'Racing Risk Coverage',
    itIsAPolicyExtension:
      'Is a policy extension which covers damages to your boat from accidents that arise from racing.',

    // SectionEasySteps //
    HeadingSectionEasySteps:
      'GET YOUR YACHT INSURANCE FROM INSURANCEMARKET.AE IN 3 EASY STEPS',
    EasyStepText1: 'Complete The Form (it takes seconds)',
    EasyStepText2: 'We Email You The Best Deals',
    EasyStepText3: 'We Email Your Yacht Insurance Documents',

    // SectionBenefits //
    HeadingSectionBenefits: 'OPTIONAL BENEFITS OF YACHT INSURANCE WITH ALFRED',
    yachtsAreBigInvestment:
      'Yachts are a big investment. At InsuranceMarket.ae we realise that you’ll probably wish to make sure your vessel is covered properly with one of our insurers, and we only work with the best.',
    owningAndBuying:
      'Owning and buying your own yacht is very personal, so we can tailor a few extra optional benefits for you if you would like them:',

    BenefitTitle1: "Water skiers' liability",
    BenefitDetail1:
      'Water skiing is great fun, but it can be dangerous. Covering the legal liability of the waterskiiers is a nice optional extra.',
    BenefitTitle2: 'Cruising range extension',
    BenefitDetail2:
      'Different length ships can go different distances from the place of mooring. However, we can get this extended upon request.',
    BenefitTitle3: 'Racing risks',
    BenefitDetail3:
      'Under a yacht comprehensive cover, we can get the policy extended to include regattas and races.',
    BenefitTitle4: 'Personal Accident',
    BenefitDetail4:
      'It might get dangerous out on the high seas, so we can add benefits for you and your spouse in case of serious accident.',
    BenefitTitle5: 'Personal Effects',
    BenefitDetail5:
      'We can arrange cover for your personal belongings and cash on board in case someone breaks in.',
    BenefitTitle6: 'Search and Rescue',
    BenefitDetail6: 'This option can be added up to $US 25,000. Just in case.',

    // SectionPromises //
    HeadingSectionPromises: "ALFRED'S HEARTFELT PROMISES",

    PromiseText1: 'Best Possible Value For Your Money',
    PromiseText2: 'Only The Most Reliable Insurance Companies',
    PromiseText3: 'Passionate Dedication To Claims Service',
    PromiseText4: 'Your Own Personal Shopper To Help You Choose',

    // SectionReviews //
    HeadingSectionReviews: "HERE'S WHAT OUR CUSTOMERS ARE SAYING",

    // SectionQuestions //
    HeadingSectionQuestions: 'SOME FREQUENTLY ASKED QUESTIONS',
    readAlfredsAdvice:
      'Read Alfred’s advice and insight on some asked questions.',

    Question1: 'Want to know more about the yacht policies and covers?',
    Answer1:
      'There are quite a few different providers of yacht insurance in the UAE. We’ve found our strong relationships with certain underwriters enable us to move away from ‘package’ policies, and create something far more appropriate for your needs.',
    learnMore: 'Learn more about yacht insurance',

    // SectionGetInsurance //
    HeadingSectionGetInsurance: 'GET YACHT INSURANCE',
    quotesInYourEmailNow: 'Quotes In Your Email Now',
    thousandsOfCustomers:
      'Thousands of customers trust InsuranceMarket.ae to get the best insurance deals',
    weWillEmailYourCustom:
      'We’ll email your custom comparison table to save you time & money',
  },
  '/typ-yacht-insurance': {
    title: 'typ-yacht-insurance',
    metaDesc:
      "One of our Personal Shoppers is working on your custom quote and will be in touch shortly. Get These Additional Offers & Savings When You Buy Insurance From Us. Protect your valuable furniture, jewellery, mobile phones and watches. With the many benefits included in home insurance, it's ...",
    // SectionBanner //
    rating: 'Rating',
    reviews: 'Reviews',
    compareYacht: 'COMPARE YACHT INSURANCE WITH ALFRED',
    floatAround: 'Float around the Gulf sea with complete peace of mind',
    getQuotes: 'Get quotes in your email',
    weWillEmail:
      'We’ll email a comparison table, help you choose and email your policy!',

    // SectionPartners //
    ourYachtInsurance: 'OUR YACHT INSURANCE PARTNERS',
    oneSizeDoesNot:
      'One size does not fit all. We work with the Leading Yacht Insurance companies in the UAE to tailor the right policy for you.',

    // SectionPleasureCraft //
    benefitsOfPleasure: 'BENEFITS OF PLEASURE CRAFT INSURANCE',

    hullnMachinery: 'Hull and Machinery',
    coversTheLoss:
      'Covers the loss or damage to your yacht caused by insured perils.',
    thirdPartyLiability: 'Third Party Liability',
    coversYouAgainst:
      'Covers you against liabilities that may arise out of injury to a third party person or damage to a property.',
    unInsuredBoater: 'Uninsured Boater',
    coversYouAndGuests:
      'Covers you and guests on your pleasure craft against bodily injury.',
    personalEffects: 'Personal Effects',
    isAnOptional:
      'Is an optional coverage which covers your personal belongings on your boat from theft.',
    searchAndRescue: 'Search and Rescue Services',
    coversExpenses:
      'Covers expenses for this service in the event assistance is required.',
    racingRiskCoverage: 'Racing Risk Coverage',
    itIsAPolicyExtension:
      'Is a policy extension which covers damages to your boat from accidents that arise from racing.',

    // SectionEasySteps //
    HeadingSectionEasySteps:
      'GET YOUR YACHT INSURANCE FROM INSURANCEMARKET.AE IN 3 EASY STEPS',
    EasyStepText1: 'Complete The Form (it takes seconds)',
    EasyStepText2: 'We Email You The Best Deals',
    EasyStepText3: 'We Email Your Yacht Insurance Documents',

    // SectionBenefits //
    HeadingSectionBenefits: 'OPTIONAL BENEFITS OF YACHT INSURANCE WITH ALFRED',
    yachtsAreBigInvestment:
      'Yachts are a big investment. At InsuranceMarket.ae we realise that you’ll probably wish to make sure your vessel is covered properly with one of our insurers, and we only work with the best.',
    owningAndBuying:
      'Owning and buying your own yacht is very personal, so we can tailor a few extra optional benefits for you if you would like them:',

    BenefitTitle1: "Water skiers' liability",
    BenefitDetail1:
      'Water skiing is great fun, but it can be dangerous. Covering the legal liability of the waterskiiers is a nice optional extra.',
    BenefitTitle2: 'Cruising range extension',
    BenefitDetail2:
      'Different length ships can go different distances from the place of mooring. However, we can get this extended upon request.',
    BenefitTitle3: 'Racing risks',
    BenefitDetail3:
      'Under a yacht comprehensive cover, we can get the policy extended to include regattas and races.',
    BenefitTitle4: 'Personal Accident',
    BenefitDetail4:
      'It might get dangerous out on the high seas, so we can add benefits for you and your spouse in case of serious accident.',
    BenefitTitle5: 'Personal Effects',
    BenefitDetail5:
      'We can arrange cover for your personal belongings and cash on board in case someone breaks in.',
    BenefitTitle6: 'Search and Rescue',
    BenefitDetail6: 'This option can be added up to $US 25,000. Just in case.',

    // SectionPromises //
    HeadingSectionPromises: "ALFRED'S HEARTFELT PROMISES",

    PromiseText1: 'Best Possible Value For Your Money',
    PromiseText2: 'Only The Most Reliable Insurance Companies',
    PromiseText3: 'Passionate Dedication To Claims Service',
    PromiseText4: 'Your Own Personal Shopper To Help You Choose',

    // SectionReviews //
    HeadingSectionReviews: "HERE'S WHAT OUR CUSTOMERS ARE SAYING",

    // SectionQuestions //
    HeadingSectionQuestions: 'SOME FREQUENTLY ASKED QUESTIONS',
    readAlfredsAdvice:
      'Read Alfred’s advice and insight on some asked questions.',

    Question1: 'Want to know more about the yacht policies and covers?',
    Answer1:
      'There are quite a few different providers of yacht insurance in the UAE. We’ve found our strong relationships with certain underwriters enable us to move away from ‘package’ policies, and create something far more appropriate for your needs...',
    readMore: 'Read more',

    // SectionGetInsurance //
    HeadingSectionGetInsurance: 'GET YACHT INSURANCE',
    quotesInYourEmailNow: 'Quotes In Your Email Now',
    thousandsOfCustomers:
      'Thousands of customers trust InsuranceMarket.ae to get the best insurance deals',
    weWillEmailYourCustom:
      'We’ll email your custom comparison table to save you time & money',
  },
};
